module.exports = __webpack_public_path__ + "ebcd50eb9417a2bc0f2d272059d4b8c1.woff";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-Italic.woff
// module id = 17
// module chunks = 0